export default __webpack_public_path__ + "static/media/trr-drink-coffee-cortado.9b713e4f.png";